<template>
  <div class="rule-container">
    <div class="rule-header">
      <div class="rule-filter-container">
        <el-select v-model="selectedRule" size="mini" @change="ruleChange">
          <el-option
            v-for="r in rules"
            :key="r.id"
            :label="r.label"
            :value="r.id"
          ></el-option>
        </el-select>
        <el-select
          v-if="subRules !== null && subRules.length > 0"
          v-model="selectedSubRule"
          size="mini"
          @change="subRuleChange"
        >
          <el-option
            v-for="r in subRules"
            :key="r.id"
            :label="r.label"
            :value="r.id"
          ></el-option>
        </el-select>
      </div>
      <div class="rule-operator-container">
        <el-select
          @change="operatorChange(query)"
          v-model="query.selectedOperator"
          size="mini"
        >
          <el-option
            v-for="operator in selectedRuleObj.operators"
            :value="operator.value"
            :key="operator.value"
            :label="operator.label"
          >
          </el-option>
        </el-select>
      </div>
      <div
        class="rule-value-container"
        v-if="
          query.selectedOperator != 'IS NOT NULL' &&
          query.selectedOperator != 'IS NULL'
        "
      >
        <template v-for="(item, index) in customItems">
          <!-- <el-form-item
              :label="item.label"
              :ref="item.prop"
              :prop="item.prop"
            > -->
          <dragFormItem
            v-if="areStringsEqualIgnoreCase(query.rule, item.field)"
            v-model="query.value"
            :key="index"
            type="complex"
            :data="item"
          ></dragFormItem>
          <!-- </el-form-item> -->
        </template>

        <!-- <el-input
          size="mini"
          v-if="
            selectedRuleObj.inputType === 'text' &&
            query.selectedOperator != 'IS NULL' &&
            query.selectedOperator != 'IS NOT NULL' &&
            selectedRuleObj.inputType != 'dataSource'
          "
          type="text"
          v-model="query.value"
          clearable
        /> -->
        <!-- <el-input-number
          v-model="query.value"
          v-if="
            selectedRuleObj.inputType === 'number' &&
            query.selectedOperator !== ';' &&
            query.selectedOperator !== '!;' &&
            query.selectedOperator != 'IS NULL' &&
            query.selectedOperator != 'IS NOT NULL'
          "
          size="mini"
          controls-position="right"
        ></el-input-number> -->

        <!-- <input-number-range
          v-if="
            (selectedRuleObj.inputType === 'number' &&
              query.selectedOperator === ';') ||
            (query.selectedOperator === '!;' &&
              selectedRuleObj.inputType === 'number' &&
              query.selectedOperator != 'IS NULL' &&
              query.selectedOperator != 'IS NOT NULL')
          "
          :precision="2"
          v-model="query.value"
        ></input-number-range>

        <el-date-picker
          size="mini"
          v-if="
            selectedRuleObj.inputType == 'datetime' &&
            query.selectedOperator !== ';' &&
            query.selectedOperator !== '!;' &&
            query.selectedOperator != 'IS NULL' &&
            query.selectedOperator != 'IS NOT NULL'
          "
          :editable="true"
          :type="selectedRuleObj.inputType"
          v-model="query.value"
        /> -->
        <!-- <el-date-picker
          v-if="
            (selectedRuleObj.inputType == 'datetime' &&
              query.selectedOperator === ';') ||
            (query.selectedOperator === '!;' &&
              selectedRuleObj.inputType === 'datetime' &&
              query.selectedOperator != 'IS NULL' &&
              query.selectedOperator != 'IS NOT NULL')
          "
          :editable="true"
          :picker-options="pickerOptions"
          v-model="query.value"
          size="mini"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
        >
        </el-date-picker> -->
        <!-- <l-layer-select
          v-if="
            selectedRuleObj.inputType === 'dataSource' &&
            query.selectedOperator != 'IS NULL' &&
            query.selectedOperator != 'IS NOT NULL'
          "
          :clearable="false"
          v-model="query.value"
          :labelKey="selectedRuleObj.labelKey"
          :valueKey="selectedRuleObj.valueKey"
          :multiple="false"
          :columns="selectedRuleObj.sourceColumns"
          :options="
            getOptions(
              selectedRuleObj.dataCode,
              selectedRuleObj.labelKey,
              selectedRuleObj.valueKey
            )
          "
        >
        </l-layer-select>
        <l-select
          v-if="
            selectedRuleObj.inputType === 'dataItem' &&
            query.selectedOperator != 'IS NULL' &&
            query.selectedOperator != 'IS NOT NULL'
          "
          size="mini"
          :options="getItems(selectedRuleObj.dataCode)"
          v-model="query.value"
        ></l-select>

        <l-user-select2
          v-if="
            selectedRuleObj.inputType === 'user' &&
            query.selectedOperator != 'IS NULL' &&
            query.selectedOperator != 'IS NOT NULL'
          "
          style="width: 200px"
          v-model="query.value"
        >
        </l-user-select2>

        <el-checkbox-group
          v-model="query.value"
          v-if="selectedRuleObj.inputType === 'checkbox'"
        >
          <el-checkbox
            :label="choice"
            v-for="choice in selectedRuleObj.choices"
            :key="choice"
            :value="choice"
          ></el-checkbox>
        </el-checkbox-group>
        <el-radio-group
          v-model="query.value"
          v-if="selectedRuleObj.inputType === 'radio'"
        >
          <el-radio
            :label="choice"
            v-for="choice in selectedRuleObj.choices"
            :key="choice"
            :value="choice"
          ></el-radio>
        </el-radio-group> -->
      </div>

      <!-- <div class="btn-group pull-right rule-actions"> -->
      <el-button
        type="text"
        icon="el-icon-close"
        @click="remove"
        style="color: #f56c6c"
      ></el-button>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import dragFormItem from "./FormItem.vue";
import deepClone from "../utils/deepClone.js";
// import InputNumberRange from "./InputNumberRange.vue";

export default {
  name: "query-builder-rule",
  props: ["query", "index", "rules", "items", "customItems"],
  components: {
    // InputNumberRange,
    dragFormItem,
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      selectedRuleObj: this.rules[0],
      selectedRule: this.query.rule || this.rules[0].id,
      selectedSubRule: null,
      subRules: [],
    };
  },
  methods: {
    areStringsEqualIgnoreCase(str1, str2) {
      return str1.toLowerCase() == str2.toLowerCase();
    },
    cloneNode() {},
    itemsToArray(items) {
      let arr = [];
      Object.keys(items).forEach(function (key) {
        let node = items[key][0];
        let obj = node;
        arr.push(obj);
      });
      return arr;
    },
    getItems(code) {
      this.lr_loadDataItem(code);
      return this.lr_dataItemOptions(this.lr_dataItem[code]);
    },
    getOptions(code, labelKey, valueKey) {
      const data = this.lr_DataSource(code);

      return this.lr_DataSourceOptions(data, valueKey, labelKey);
    },
    remove: function () {
      this.$emit("child-deletion-requested", this.index);
    },
    operatorChange: function () {
      //
      // _this.query.value = _this.query.selectedOperator == ";" ? [] : null;
    },
    ruleChange: function () {
      const _this = this;

      _this.query.selectedOperator = "=";
      this.query.value = "";
      this.subRules = [];
      this.selectedSubRule = null;
      this.rules.forEach(function (value) {
        if (value.id === _this.selectedRule) {
          if (
            value.subRules !== undefined &&
            value.subRules !== null &&
            value.subRules.length > 0
          ) {
            _this.subRules = value.subRules;
          } else {
            _this.query.type = value.type;
            _this.selectedRuleObj = value;
            _this.query.rule = _this.selectedRule;
            _this.initValue();
          }
        }
      });
      this.query.selectedOperator = this.selectedRuleObj.operators[0].value;
    },
    subRuleChange: function () {
      const _this = this;
      this.query.value = null;
      this.subRules.forEach(function (value) {
        if (value.id === _this.selectedSubRule) {
          _this.selectedRuleObj = value;
          _this.query.selectedOperator =
            _this.selectedRuleObj.operators[0].value;
          _this.query.rule = _this.selectedRule + "-" + _this.selectedSubRule;
          _this.initValue();
        }
      });
    },
    initValue() {
      if (this.query.value === null) {
        const updated_query = deepClone(this.query);
        if (this.selectedRuleObj.inputType === "checkbox") {
          updated_query.value = [];
        }
        if (
          this.selectedRuleObj.inputType === "select" ||
          this.selectedRuleObj.inputType === "radio"
        ) {
          updated_query.value = this.selectedRuleObj.choices[0];
        }
        if (
          this.selectedRuleObj.inputType === "time" ||
          this.selectedRuleObj.inputType === "date" ||
          this.selectedRuleObj.inputType === "datetime"
        ) {
          updated_query.value = Math.round(new Date());
        }
        this.$emit("update:query", deepClone(updated_query));
      }
    },
  },
  mounted() {
    // Set a default value for these types if one isn't provided already
    this.initValue();

    var _this = this;
    var selectedRuleCopy = _this.selectedRule;
    var splitIndex = selectedRuleCopy.indexOf("-");
    if (splitIndex > -1) {
      _this.selectedRule = selectedRuleCopy.substring(0, splitIndex);
      _this.selectedSubRule = selectedRuleCopy.substring(splitIndex + 1);
      this.rules.forEach(function (rule) {
        if (rule.id === _this.selectedRule) {
          var isBreak = false;
          _this.subRules = rule.subRules;
          rule.subRules.forEach(function (subRule) {
            if (subRule.id === _this.selectedSubRule) {
              _this.selectedRuleObj = subRule;
              isBreak = true;
              return false;
            }
          });
          if (isBreak) {
            return false;
          }
        }
      });
    } else {
      this.rules.forEach(function (rule) {
        if (rule.id === _this.selectedRule) {
          _this.selectedRuleObj = rule;
          return false;
        }
      });
    }
  },
};
</script>
